export default "__VITE_ASSET__BUuFn5rj__"